var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"lg":"8"}},[_c('card',[_c('ChannelTable',{on:{"selectItem":_vm.onSelectItem,"newItem":_vm.onNewItem}})],1)],1),_c('b-col',[(_vm.action == '')?_c('InfoCard'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }